import React from 'react';
import Image from 'next/image';
import GlpLogo from '../../../public/logo.png';

export default function Logo() {
  return (
    <div>
      <Image src={GlpLogo} height={100} width={550} alt="logo" />
    </div>
  );
}
